import styled from 'styled-components';

export const SearchIcon = styled.i.attrs(() => ({
  className: 'mi-search',
}))` ${({ theme }) => `
    font-size:${theme.fontSize[4]};
    color:${theme.colours.neutral[5]};
`}`;
